import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Practice } from 'src/app/interfaces/practice';
import { PracticeService } from 'src/app/services/practice.service';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorService } from 'src/app/services/error.service';

//fk
import { ManagmentService } from 'src/app/services/managment.service';
import { CareerService } from 'src/app/services/career.service';
import { CenterService } from 'src/app/services/center.service';
import { AreaService } from 'src/app/services/area.service';
import { TurnService } from 'src/app/services/turn.service';
import { AreaCenterService } from 'src/app/services/area-center.service';
import { PracticeInscriptionService } from 'src/app/services/practiceinscription.service';

import { Managment } from 'src/app/interfaces/managment';
import { Career } from 'src/app/interfaces/career';
import { Center } from 'src/app/interfaces/center';
import { Area } from 'src/app/interfaces/area';
import { Turn } from 'src/app/interfaces/turn';
import { AreaCenter } from 'src/app/interfaces/area-center';
import { PracticeInscription } from 'src/app/interfaces/practiceinscription';

@Component({
  selector: 'app-add-edit-practice',
  templateUrl: './add-edit-practice.component.html',
  styleUrls: ['./add-edit-practice.component.css']
})
export class AddEditPracticeComponent implements OnInit {
  form: FormGroup;
  loading: boolean = false;
  id: number;
  operacion: string = 'Agregar ';
  idUserPractice: number=0;
  idcenter: number=0;

  listAreaCenters: AreaCenter[] = []

  managments: Managment[] = [];
  careers: Career[] = [];
  centers: Center[] = [];
  areas: Area[] = [];
  turns: Turn[] = [];
  areacenterturns: AreaCenter[] = [];

  selectedManagment: Managment | null = null;
  selectedCareer: Career | null = null;
  selectedCenter: Center | null = null;
  selectedArea: Area | null = null;
  selectedTurn: Turn | null = null;
  selectedAreaCenterTurn: AreaCenter | null = null;

  constructor(private fb: FormBuilder,
    private _practiceService: PracticeService,
    private router: Router,
    private toastr: ToastrService,
    private aRouter: ActivatedRoute,
    private _managmentService: ManagmentService,
    private _careerService: CareerService,
    private _areaService: AreaService,
    private _centerService: CenterService,
    private _turnService: TurnService,
    private _areacenterturnService: AreaCenterService,
    private _practiceInscriptionService: PracticeInscriptionService,
    private _errorService: ErrorService
    ) {
    this.form = this.fb.group({
      /*namearea: ['', Validators.required],
      lastnamearea: ['', Validators.required],
      ci: ['', Validators.required],
      namecenter: ['', Validators.required],*/
      idmanagment: ['', Validators.required],
      idcareer: ['', Validators.required],
     /* idarea: ['', Validators.required],
      idcenter: ['', Validators.required],
      idturn: ['', Validators.required],*/
      idareacenterturn: ['', Validators.required],
      quota: ['', Validators.required],
    })
    this.id = Number(aRouter.snapshot.paramMap.get('id'));
  }

  ngOnInit(): void {
    // Obtener la lista de gestiones
    this._managmentService.getListManagments().subscribe((managments: Managment[]) => {
      this.managments = managments;
    }, (error) => {
      console.error('Error al obtener las gestiones:', error);
    });

    // Obtener la lista de carreras
    this._careerService.getListCareers().subscribe((careers: Career[]) => {
      this.careers = careers;
    }, (error) => {
      console.error('Error al obtener las carreras:', error);
    });
    
    // Obtener la lista de area-centro-turno
    this._areacenterturnService.getListAreaCenters().subscribe((data: AreaCenter[]) => {
      data.forEach(areacenter => {
        if (areacenter && areacenter.idarea && areacenter.idcenter)  {
          //obteniendo area
          this._areaService.getArea(areacenter.idarea).subscribe((area: any) => {
            if (area) {
                areacenter.namearea = area.name;
            } else {
                console.warn('Area nulo:', area);
            }
            
        }, (error) => {
            console.error('Error al obtener el area:', error);
        });
        
        //obteniendo centro
        this._centerService.getCenter(areacenter.idcenter).subscribe((center: any) => {
          if (center) {
              areacenter.namecenter = center.name;
          } else {
              console.warn('Centro nulo:', center);
          }}, (error) => {
            console.error('Error al obtener la carrera:', error);
        });
         //obteniendo turno
         this._turnService.getTurn(areacenter.idturn).subscribe((turn: any) => {
          if (turn) {
              areacenter.nameturn = turn.name;
              //console.log("areacenter.nameturn: " + areacenter.nameturn);
          } else {
              console.warn('Turno nulo:', turn);
          }}, (error) => {
            console.error('Error al obtener el turno:', error);
        });

        } else {
          console.warn('Area de centro nula, sin id de centro o id de area:', areacenter);
      }
      });
      this.listAreaCenters = data;
      this.loading = false;
    }, (error) => {
        console.error('Error al obtener la lista de area-centro-turno:', error);
        this.loading = false;
    });

    // Obtener la lista de centros
   /* this._centerService.getListCenters().subscribe((centers: Center[]) => {
      this.centers = centers;
    }, (error) => {
      console.error('Error al obtener las centros:', error);
    });

    // Obtener la lista de areas
    this._areaService.getListAreas().subscribe((areas: Area[]) => {
      this.areas = areas;
    }, (error) => {
      console.error('Error al obtener las areas:', error);
    });
    // Obtener la lista de turnos
    this._turnService.getListTurns().subscribe((turns: Turn[]) => {
      this.turns = turns;
    }, (error) => {
      console.error('Error al obtener los turnos:', error);
    });*/

    if (this.id != 0) {
      // Es editar
      this.operacion = 'Editar ';
      this.getPractice(this.id);
    }
  }

  /*getPractice(id: number) {
    this.loading = true;
    this._practiceService.getPractice(id).subscribe((data: Practice) => {
      this.loading = false;
      this.form.setValue({
        name: data.name,
        lastname: data.lastname,
        ci: data.ci,
        email: data.userid
      })
    })
  }*/
  selectManagment(managment: Managment) {
    this.selectedManagment = managment;
    this.form.patchValue({
      idmanagment: managment.id
    });
  }

  selectCareer(career: Career) {
    this.selectedCareer = career;
    this.form.patchValue({
      idcareer: career.id
    });
  }

/*  selectCenter(center: Center) {
    this.selectedCenter = center;
    this.form.patchValue({
      idcenter: center.id
    });
  }

  selectArea(area: Area) {
    this.selectedArea = area;
    this.form.patchValue({
      idarea: area.id
    });
  }

  selectTurn(turn: Turn) {
    this.selectedTurn = turn;
    this.form.patchValue({
      idturn: turn.id
    });
  }
*/
  selectAreaCenterTurn(areacenter: AreaCenter) {
    this.selectedAreaCenterTurn = areacenter;
    this.form.patchValue({
      idareacenterturn: areacenter.id
    });
  }

  getPractice(id: number) {
    this.loading = true;
    this._practiceService.getPractice(id).subscribe((data: Practice) => {
      this.loading = false;
      console.log("quota en data: "+ data.quota);

      this.form.patchValue({
        quota: data.quota
      });

      //obtener gestion
      if (data.idmanagement !== undefined) {
        this._managmentService.getManagment(data.idmanagement).subscribe((data2: Managment) => {
          this.loading = false;
          this.form.patchValue({
            idmanagment: data2.id
          });
        })
      } else {
        console.error('El ID de Gestión es undefined.');
      }
      
      //obtener carrera
      if (data.idcareer !== undefined) {
        this._careerService.getCareer(data.idcareer).subscribe((data2: Career) => {
          this.loading = false;
          //console.log("valores de Career: "+data2.id);
          this.form.patchValue({
            idcareer: data2.id
          });
        })
      } else {
        console.error('El ID de Carrera es undefined.');
      }
      // obtener area-center-turn
      if (data.idareacenterturn !== undefined) {
      console.log("id de area centro turno: "+data.idareacenterturn);
      this._areacenterturnService.getAreaCenter(data.idareacenterturn).subscribe((data: AreaCenter) => {
        this.loading = false
        this.form.patchValue({
          idareacenterturn: data.id
        });

        //obtener carrera
        if (data.idcenter !== undefined) {
          this._centerService.getCenter(data.idcenter).subscribe((data2: Center) => {
            this.loading = false;
            //console.log("valores de Center: "+data2.id);
            this.form.patchValue({
              idcenter: data2.id
            });
          })
        } else {
          console.error('El ID de centro es undefined.');
        }
  
        //obtener area
        if (data.idarea !== undefined) {
          this._areaService.getArea(data.idarea).subscribe((area: Area) => {
            //console.log("area.id: "+area.id);
            this.form.patchValue({
              idarea: area.id
            });
          }, (error) => {
            console.error('Error al obtener el area de centro:', error);
          });
        } else {
          console.error('El ID de area es undefined.');
        }
  
        //obtener turno
        if (data.idturn !== undefined) {
          //console.log("user.email: "+data.userid)
          this._turnService.getTurn(data.idturn).subscribe((turn: Turn) => {
            //console.log("area.id: "+area.id);
            this.form.patchValue({
              idareacenterturn: data.id
            });
          }, (error) => {
            console.error('Error al obtener el turno de centro:', error);
          });
        } else {
          console.error('El ID de turno es undefined.');
        }
      });
      } else {
        console.error('El ID de area-centro-turno es undefined.');
      }
    });
  }
  
  
  
  addPractice() {
    let practice: Practice = {
      idmanagement: this.form.value.idmanagment,
      idcareer: this.form.value.idcareer,
      /*idarea: this.form.value.idarea,
      idcenter: this.form.value.idcenter,
      idturn: this.form.value.idturn,*/
      idareacenterturn: this.form.value.idareacenterturn,
      quota: this.form.value.quota,
      enrolled: 0,
      state: 1
    };

    /*if (!this.isEmail(this.form.value.email)) {
      console.log("Email: " + this.form.value.email);
      this.toastr.error('El campo email campo debe ser un correo electrónico', 'Error');
      return;
    }*/

    /*let pass: string;
    pass = Math.floor(1000 + Math.random() * 9000).toString();
    this.addUserParams(this.form.value.email, pass, 2);*/
    //console.log("valores enviados practice id area: "+practice.idarea+", idcenter: "+practice.idcenter);
    this.saveOrUpdatePractice(practice);
    /*
    this._userService.getLastUser().subscribe(
      (user: User) => {
        this.lastUser = user;
        this.idUserPractice = this.lastUser?.id != null ? this.lastUser.id + 1 : 0;
        console.log('Último usuario:', this.lastUser.id);
        practice.userid = this.idUserPractice; // Actualizamos userid con el valor obtenido
        this.saveOrUpdatePractice(practice);
      },
      (error) => {
        console.error('Error al obtener el último usuario:', error);
      }
    );*/
}
saveOrUpdatePractice2(practice: Practice) {
  this.loading = true;

  if (this.id !== 0) {
      // Es editar
      practice.id = this.id;
      this._practiceService.updatePractice(this.id, practice).subscribe(() => {
          this.toastr.info(`Se actualizó la práctica con éxito`, 'Práctica actualizada');
          this.loading = false;
          this.router.navigate(['/practice']);
      });
  } else {
      // Es agregar
      this._practiceService.savePractice(practice).subscribe(() => {
          this.toastr.success(`La práctica fue agregada con éxito`, 'Práctica registrada');
          this.loading = false;
          this.router.navigate(['/practice']);
      });
  }
}
saveOrUpdatePractice(practice: Practice) {
    this.loading = true;

    if (this.id !== 0) {
      // Es editar 
    //  console.log("Editando: " + practice);
this._practiceInscriptionService.getPracticeInscriptionsByPracticeId(this.id).subscribe(
        (inscriptions: PracticeInscription[]) => {
          console.log("inscriptions.length: "+inscriptions.length);
            if (inscriptions.length > 0) {
                // Si hay inscripciones asociadas, mostrar un mensaje de error
                this.toastr.error('No se puede actualizar la práctica porque tiene inscripciones asociadas', 'Error');
                this.loading = false;
            } else {

      practice.id = this.id;
      this._practiceService.updatePractice(this.id, practice).subscribe(() => {
        this.toastr.info(`Se actualizo la práctica con exito`, 'Práctica actualizada');
        this.loading = false;
        this.router.navigate(['/practice']);
      });
    }
      },
      (error) => {
          console.error('Error al verificar las inscripciones asociadas:', error);
          this.toastr.error('Error al verificar las inscripciones asociadas', 'Error');
          this.loading = false;
      }
    );
    } else {
      // Es agregar
     // console.log("Agregando: " + practice);
      this._practiceService.savePractice(practice).subscribe(() => {
        this.toastr.success(`La práctica fue agregada con exito`, 'Práctica registrada');
        this.loading = false;
        this.router.navigate(['/practice']);
      });
    }
}
  
  /*addUserParams(email:string, password:string, rol:number) {
    //Validamos que el username sea un correo
    if (!this.isEmail(email)) {
      this.toastr.error('El primer campo debe ser un correo electrónico', 'Error');
      return;
    }
    // Validamos que el usuario ingrese valores
    if (email == '' || password == '') {
      this.toastr.error('Todos los campos son obligatorios', 'Error');
      return;
    }
    // Creamos el objeto
    const user: User = {
      username: email,
      password: password,
      rol: rol
    }
    this.loading = true;
    this._userService.signIn(user).subscribe({
      next: (v) => {
        this.loading = false;
        this.toastr.success(`El usuario ${email} fue registrado con exito`, 'Usuario registrado');
        //this.router.navigate(['/login']);

        // Aquí puedes acceder a los valores del usuario
        const id = v.id;
        const email2 = v.email;
        // Realiza las acciones necesarias con los valores del usuario
        //console.log("Usuario id: "+id+ ", email: "+email2); 
        
      },
      error: (e: HttpErrorResponse) => {
        this.loading = false;
        this._errorService.msjError(e);
      }
    })
    
  }
  generateRandomNumber(): number {
    return Math.floor(1000 + Math.random() * 9000);
  }
  isEmail(email: string): boolean {
    // Expresión regular para validar un correo electrónico
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }*/
}
